import type { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './MultiButton.module.css';

import { Close } from '../../../icons/Close';
import { ButtonBase, type ButtonBaseProps } from '../../ButtonBase';
import { Text } from '../../Text';

export interface MultiButtonProps extends ButtonBaseProps {
  children: ReactNode;
  className?: string;
}

export function MultiButton({
  children,
  className,
  ...props
}: MultiButtonProps) {
  return (
    <Text asChild color="White">
      <ButtonBase
        className={classNames(styles.button, className)}
        type="button"
        {...props}
      >
        {children}
        <Close baseColor="White" size={11} className={styles.icon} />
      </ButtonBase>
    </Text>
  );
}
